const INITIAL_STATE = {
  docksList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DOCKS': {
      return { ...state, docksList: action.docks };
    }
    default:
      return state;
  }
};
